/* The Tea Club (sections/club-join.liquid).
   <club-join>: plan picker total, gift tick-box (also from ?gift and [data-gift] links), "Leave out",
   add to bag through MKBag.add (source "club"), view_item on load.
   <club-sticky>: the "Join the Club" bar. Shows once the header (.cl-hero) is behind you,
   hides while the plans (#join) are on screen. */
(function () {
  var inr = function (cents) {
    if (window.MK && MK.inr) return MK.inr(cents / 100);
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  };
  var json = function (el) { try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } };

  if (!customElements.get('club-join')) {
    customElements.define('club-join', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.meta = json(this.querySelector('[data-club-product]'));
        this.msg = { ok_gift: this.dataset.okGift, ok_one: this.dataset.okOne, ok_other: this.dataset.okOther };
        this.gift = this.form.querySelector('[data-club-gift]');
        this.onChange = this.sync.bind(this);
        this.onSubmit = this.submit.bind(this);
        this.onGiftLink = function (e) {
          if (e.target.closest('[data-gift]')) this.setGift(true);
        }.bind(this);
        this.form.addEventListener('change', this.onChange);
        this.form.addEventListener('submit', this.onSubmit);
        document.addEventListener('click', this.onGiftLink);
        if (/[?&]gift\b/.test(location.search)) this.setGift(true);
        this.sync();
        if (this.meta.item_id && window.MK && MK.track && !this.tracked) {
          this.tracked = true;
          MK.track('view_item', { item_id: this.meta.item_id, item_name: this.meta.item_name, price: this.meta.price, currency: this.meta.currency, source: 'club' });
        }
      }

      disconnectedCallback() {
        if (!this.form) return;
        this.form.removeEventListener('change', this.onChange);
        this.form.removeEventListener('submit', this.onSubmit);
        document.removeEventListener('click', this.onGiftLink);
      }

      checked() { return this.form.querySelector('input[name="id"]:checked'); }

      setGift(on) {
        if (!this.gift) return;
        this.gift.checked = on;
        this.sync();
      }

      sync() {
        var form = this.form, m = this.checked(), giftOn = this.gift && this.gift.checked;
        form.querySelectorAll('.mopt').forEach(function (o) { o.classList.toggle('on', o.querySelector('input').checked); });
        var total = form.querySelector('[data-club-total]');
        if (total && m) total.textContent = inr(+m.dataset.price);
        form.querySelectorAll('[data-gift-field]').forEach(function (f) {
          f.hidden = !giftOn;
          var i = f.querySelector('input');
          if (i) { i.disabled = !giftOn; i.required = !!giftOn; }
        });
      }

      submit(e) {
        var form = this.form, m = this.checked();
        if (!window.MKBag) return; /* no drawer: native POST to /cart/add */
        e.preventDefault();
        if (!m || !m.value) return;
        if (!form.reportValidity()) return;
        var props = {}, giftOn = this.gift && this.gift.checked;
        if (giftOn) {
          props.Gift = 'Yes';
          form.querySelectorAll('[data-gift-field] input').forEach(function (i) {
            var k = (i.name.match(/^properties\[(.+)\]$/) || [])[1], v = i.value.trim();
            if (k && v) props[k] = v;
          });
        }
        var leave = Array.prototype.filter.call(form.querySelectorAll('[data-leave-out]'), function (c) { return c.checked; })
          .map(function (c) { return c.value; });
        if (leave.length) props['Leave out'] = leave.join(', ');

        var btn = form.querySelector('[type="submit"]'), err = form.querySelector('[data-add-error]'), ok = form.querySelector('[data-club-ok]');
        var months = +m.dataset.months || 1, msg = this.msg;
        btn.disabled = true; btn.setAttribute('aria-busy', 'true');
        if (err) err.hidden = true;
        window.MKBag.add({ id: m.value, quantity: 1, properties: props }, {
          source: 'club',
          analytics: { plan: m.dataset.plan, gift: !!giftOn }
        }).then(function () {
          if (ok) {
            ok.textContent = giftOn ? msg.ok_gift : (months === 1 ? msg.ok_one : String(msg.ok_other || '').replace('%n', months));
            ok.classList.add('sig');
          }
        }).catch(function (x) {
          if (err) { err.textContent = x && x.message ? x.message : String(x); err.hidden = false; }
        }).then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
      }
    });
  }

  if (!customElements.get('club-sticky')) {
    customElements.define('club-sticky', class extends HTMLElement {
      connectedCallback() {
        var hero = document.querySelector('.cl-hero'), join = document.getElementById('join');
        if (!join || !('IntersectionObserver' in window)) return;
        var seen = { hero: !!hero, join: false }, bar = this;
        var sync = function () { bar.hidden = seen.hero || seen.join; };
        this.io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { seen[e.target === join ? 'join' : 'hero'] = e.isIntersecting; });
          sync();
        }, { threshold: 0 });
        if (hero) this.io.observe(hero);
        this.io.observe(join);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        this.io = null;
      }
    });
  }
})();
